import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import type { Patient } from '@/types/patient';

export const usePatientsData = () => {
  const [patients, setPatients] = useState<Patient[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchPatients = async () => {
    try {
      const { data, error } = await supabase
        .from('patients')
        .select('*')
        .eq('is_active', true)
        .order('created_at', { ascending: false });

      if (error) throw error;
      
      // Transform the data to match our Patient type
      const transformedPatients: Patient[] = (data || []).map(patient => ({
        ...patient,
        insurance_info: patient.insurance_info ? 
          (typeof patient.insurance_info === 'object' ? patient.insurance_info as Record<string, any> : {}) : undefined,
        allergies: patient.allergies || [],
        medical_conditions: patient.medical_conditions || []
      }));
      
      setPatients(transformedPatients);
    } catch (error) {
      console.error('Error fetching patients:', error);
      toast.error('Failed to load patients');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPatients();
  }, []);

  return {
    patients,
    setPatients,
    loading,
    fetchPatients
  };
};
